<template>
  <b-navbar toggleable="lg" type="dark" sticky class="header">
    <div class="container">
      <b-navbar-toggle target="nav-collapse" />
      <b-nav class="nav-menu nav-menu-tabs ml-auto">
        <b-nav-item :to="{name: 'WorkspaceHome'}" exact><home-icon /></b-nav-item>
        <b-nav-item :to="{name: 'KudosLibrary'}"><kudos-icon /></b-nav-item>
        <b-nav-item :to="{name: 'Inbox'}" class="position-relative">
          <messaging-icon />
          <b-badge v-if="countMessages > 0" class="badge-message">{{ countMessages }}</b-badge>
        </b-nav-item>
        <b-nav-item :to="{name: 'UserProfile', params: { userId: profile.id }}">
          <avatar :src="profile.photo" :default-svg="defaultProfileIcon" size="1.25rem" />
        </b-nav-item>
        <b-nav-item-dropdown :toggle-class="{ 'router-link-active': isTeamRoute }" menu-class="nav-dropdown-menu">
            <template #button-content>
              <team-icon />
            </template>
            <b-dropdown-item v-for="team in teams" :key="team.id"
              :to="{name: 'Team', params: { teamId: team.id }}" exact>
              <avatar variant="teambig" :src="team.photo" rounded="lg" size="2.7rem" font-size="2rem" class="mr-2" />
              {{ team.name }}
            </b-dropdown-item>
            <template v-if="canCreateTeam">
              <b-dropdown-divider />
              <b-dropdown-item @click="$emit('create-team')">
                <b-avatar icon="plus" size="2.7rem" class="mr-2" />
                Create team
              </b-dropdown-item>
            </template>
        </b-nav-item-dropdown>
        <b-nav-item :to="{name: 'Dashboard'}"><reports-icon /></b-nav-item>
      </b-nav>
      <b-nav class="nav-menu nav-menu-right ml-auto">
        <b-nav-item :to="{name: 'Settings'}"><settings-icon /></b-nav-item>
        <b-nav-item @click="$emit('logout')">Logout</b-nav-item>
      </b-nav>
    </div>
  </b-navbar>
</template>

<script>
import HomeIcon from '@/assets/images/home.svg'
import KudosIcon from '@/assets/images/kudos.svg'
import MessagingIcon from '@/assets/images/messaging.svg'
import ProfileIcon from '@/assets/images/profile.svg'
import TeamIcon from '@/assets/images/team.svg'
import ReportsIcon from '@/assets/images/reports.svg'
import SettingsIcon from '@/assets/images/settings.svg'
import Avatar from '@/components/common/Avatar'

export default {
  name: 'Header',

  props: {
    profile: {
      type: Object,
      default: () => ([])
    },

    teams: {
      type: Array,
      default: () => ([])
    },

    canCreateTeam: {
      type: Boolean,
      default: true
    },

    countMessages: {
      type: Number,
      default: 0
    }
  },

  computed: {
    isTeamRoute() {
      return this.$route.name === 'Team'
    }
  },

  data() {
    return {
      defaultProfileIcon: ProfileIcon
    }
  },

  components: {
    HomeIcon,
    KudosIcon,
    MessagingIcon,
    TeamIcon,
    SettingsIcon,
    ReportsIcon,
    Avatar
  }
}
</script>
